/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlCreateTrialRequest
 */
export interface ControlCreateTrialRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlCreateTrialRequest
     */
    coalition_policy_number: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCreateTrialRequest
     */
    email: string;
}

/**
 * Check if a given object implements the ControlCreateTrialRequest interface.
 */
export function instanceOfControlCreateTrialRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "coalition_policy_number" in value;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function ControlCreateTrialRequestFromJSON(json: any): ControlCreateTrialRequest {
    return ControlCreateTrialRequestFromJSONTyped(json, false);
}

export function ControlCreateTrialRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCreateTrialRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'coalition_policy_number': json['coalition_policy_number'],
        'email': json['email'],
    };
}

export function ControlCreateTrialRequestToJSON(value?: ControlCreateTrialRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'coalition_policy_number': value.coalition_policy_number,
        'email': value.email,
    };
}

